/**
 * Cardo — Demo Site Profiles
 *
 * Realistic project configurations for the Hoffman pilot demo.
 * Numbers are based on industry data, not magic constants:
 *   - Crew sizes from ENR typical project staffing
 *   - New worker % from BLS construction turnover
 *   - Equipment counts from typical mid-rise logistics
 */

import type { SiteProfile } from "./types";

export const DEMO_PROFILES: SiteProfile[] = [
  {
    project_id: "hoffman-waterfront",
    project_name: "Portland Waterfront Tower",
    location_name: "Portland, OR",
    latitude: 45.5152,
    longitude: -122.6784,
    schedule_phases: ["steel_erection", "concrete_formwork"],
    concurrent: 1,
    pressure: 0.15,
    workforce: {
      total_workers: 92,
      new_workers_under_90_days: 18,
      trades_on_site: 6,
      overtime_hours_this_week: 4.5,
      night_shift: false,
    },
    compliance: {
      open_violations: 1,
      violations_last_7_days: 0,
      violations_last_30_days: 2,
      ppe_compliance_rate: 91,
      days_since_last_incident: 45,
      toolbox_talk_completed_today: false,
    },
    equipment: {
      cranes_active: 1,
      heavy_equipment_count: 3,
      man_lifts_active: 2,
      concrete_pumps_active: 1,
      critical_lifts_planned: false,
    },
  },
  {
    project_id: "hoffman-beaverton",
    project_name: "Beaverton Medical Center",
    location_name: "Beaverton, OR",
    latitude: 45.4871,
    longitude: -122.8037,
    schedule_phases: ["interior_finishes"],
    concurrent: 0,
    pressure: 0.4,
    workforce: {
      total_workers: 45,
      new_workers_under_90_days: 5,
      trades_on_site: 8,
      overtime_hours_this_week: 8,
      night_shift: false,
    },
    compliance: {
      open_violations: 0,
      violations_last_7_days: 0,
      violations_last_30_days: 1,
      ppe_compliance_rate: 95,
      days_since_last_incident: 120,
      toolbox_talk_completed_today: true,
    },
    equipment: {
      cranes_active: 0,
      heavy_equipment_count: 0,
      man_lifts_active: 4,
      concrete_pumps_active: 0,
      critical_lifts_planned: false,
    },
  },
  {
    project_id: "demo-excavation",
    project_name: "Highway 26 Interchange",
    location_name: "Hillsboro, OR",
    latitude: 45.5051,
    longitude: -122.96,
    schedule_phases: ["sitework_excavation"],
    concurrent: 0,
    pressure: 0.0,
    workforce: {
      total_workers: 28,
      new_workers_under_90_days: 3,
      trades_on_site: 3,
      overtime_hours_this_week: 2,
      night_shift: false,
    },
    compliance: {
      open_violations: 0,
      violations_last_7_days: 0,
      violations_last_30_days: 0,
      ppe_compliance_rate: 97,
      days_since_last_incident: 200,
      toolbox_talk_completed_today: true,
    },
    equipment: {
      cranes_active: 0,
      heavy_equipment_count: 5,
      man_lifts_active: 0,
      concrete_pumps_active: 0,
      critical_lifts_planned: false,
    },
  },
];
